var keyMirror = require('keymirror');

module.exports = keyMirror({
    STACKEDBAR_RESPONSE: null,
    HISTOGRAM_CSV: null
});